module.exports = __webpack_public_path__ + "static/logo_white-af989247a8166d4dbc5c281a28deccab.png";